import axios from 'axios';
import { Loading, Message } from 'element-ui';
import store from '../store';
import router from '../router';
import { getToken } from '@/utils/auth';
import { refreshToken } from '@/api/login';
import { formatError } from '@/utils/index';
import { errorNot } from '@/utils/message';
import Qs from 'qs';

// 创建axios实例
const service = axios.create({
  /* process.env.BASE_API*/
  baseURL: window.baseapi, // api的base_url
  // 请求超时时间
  timeout: 10*60*1000,
  paramsSerializer: function(params) {
    return Qs.stringify(params, {arrayFormat: 'repeat'})
  },
});

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = 'Bearer ' + getToken(); // 让每个请求携带自定义token
  }
  return config;
}, error => {
  Message.error({
    message: '网络错误'
  });
  Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use(
  response => {
    //console.log('interceptors:' + JSON.stringify(response.data) + '----');
    const res = response.data;
    /* if(response.data) {
              	return response.data;
              } else { //返回数据直接在response里
              	return response;
              }*/

// console.log("response",response);

    return response.data;
  },
  error => {
    if ((error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) || error.message.indexOf('Network') !== -1) {
      Message.error({
        message: '网络错误：服务器请求超时，请刷新重试'
      });
    }

    if(!error.response){
        console.error('request.js,error.response',error);
    }
    else if (error.response.status == 401) {
      store.dispatch('FedLogOut').then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
        Message.error({
          message: '登录已过期'
        });
      });
      return Promise.reject(error);
    } else if (error.response.status == 503) {
      store.dispatch('FedLogOut').then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
        Message.error({
          message: '服务器维护中'
        });
      });
    } else if (error.response.status == 500) {
      
      // console.log(87787878)
      Message.error({
        message: '服务器错误'
      });
      return Promise.reject(error.response);

    } else if (error.response.status == 403) { // 无权限
      router.replace({
        path: '/403'
      });
    } else if (error.response.status == 400) {
      return Promise.reject(error.response);
    } else {
      errorNot(formatError(error.response.data.errors));
      return Promise.reject(error.response.data.errors);
    }
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js